// Version : 0.0.1
// Author : NANDHAKUMAR
// LastEdit : NANDHAKUMAR
// Last ADD : INACTIVE MEMBER REPORT
// MODIFIED DATE: 29-09-2025
import { takeLatest, put, all, call } from 'redux-saga/effects';
import InActiveMemberActionTypes from './in-active-member.types';
import { InActiveMemberListGet } from './in-active-member.service';
import {
	getInActiveMemberDetailsSuccess,
	getInActiveMemberDetailsFailure,
	getInActiveMemberDetailsResponseChanged,
} from './in-active-member.action';
import { encryptData } from '../../_common/enode-decode';

import AlertManager from '../../../utils/alertManager';
/** *********************  START GET INACTIVE MEMBER REPORT DETAILS  ******************** */
export function* getInActiveMemberList({ payload }: any) {
	try {
		const key = 'GetInActiveMemberReportKey';
		const {
			companyID,
			searchType,
			branchID,
			centerID,
			groupID,
			funderID,
			databaseName,
			fromDate,
			toDate,
			userLevel,
			Limit,
			tillDate,
			userRoleName,
		} = payload;
		const jsonData = {
			CompanyID: companyID,
			SearchType: searchType,
			BranchID: branchID,
			CenterID: centerID,
			GroupID: groupID,
			FunderID: funderID,
			DatabaseName: databaseName,
			FromDate: fromDate,
			ToDate: toDate,
			UserLevel: userLevel,
			UserRoleName: userRoleName,
			Limit: Limit,
			TillDate: tillDate,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(InActiveMemberListGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getInActiveMemberDetailsFailure(responseData.data));
		} else {
			yield put(getInActiveMemberDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getInActiveMemberDetailsFailure(error));
	}
}

export function* resetGetInActiveMemberListResponse() {
	yield put(getInActiveMemberDetailsResponseChanged());
}

export function* onGetInActiveMemberListDetails() {
	yield takeLatest(
		InActiveMemberActionTypes.GET_INACTIVE_MEMBER_LIST_START,
		getInActiveMemberList,
	);
}

export function* onGetInActiveMemberListResponseReset() {
	yield takeLatest(
		InActiveMemberActionTypes.GET_INACTIVE_MEMBER_LIST_RESPONSE_RESET,
		resetGetInActiveMemberListResponse,
	);
}
/** *********************  END GET INACTIVE MEMBER REPORT LIST ******************** */

export function* reportInActiveMemberSaga() {
	yield all([call(onGetInActiveMemberListDetails), call(onGetInActiveMemberListResponseReset)]);
}
